module.exports = __webpack_public_path__ + "static/media/main.c4cb2098.png";